import { Pagination, Spin, Table } from 'antd'
import { Loader } from '../utils/Loader'

function Tables(props) {
    console.log("props", props)
    const { columns, tableData, current, handlePagination, totalPage, isLoading } = props
    console.log("props", props)

    return (
        <div>
            {isLoading ? <Spin  fullscreen /> :
                <Table
                    columns={columns}
                    dataSource={tableData}
                    scroll={{ x: true }}
                    pagination={false}
                    rowKey={(record) => record._id}
                    footer={() => (
                        <div className="pagination">
                            <Pagination
                                current={current}
                                onChange={handlePagination}
                                total={totalPage ? totalPage * 10 : 0}
                            />
                        </div>
                    )}
                />}
        </div>
    )
}

export default Tables